<button
  class="btn-change"
  sdButton
  type="secondary"
  fullWidth="true"
  (click)="openModal()"
  data-testid="changeDelivery"
  ngbTooltip="{{ text }}"
  triggers="manual"
  tabindex="-1"
>
  <cx-icon type="POINT"></cx-icon>
  {{ text }}
</button>
